import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Manifesto from "@/components/Manifesto";
import Instructor from "@/components/Instructor";
import RegistrationForm from "@/components/RegistrationForm";
import Footer from "@/components/Footer";

export default function Landing() {
  return (
    <div className="bg-background" data-testid="landing-page">
      <Navbar />
      <Hero />
      <Marquee />
      <Manifesto />
      <Instructor />
      <RegistrationForm />
      <Footer />
    </div>
  );
}
